/*
 * 动态路由的配置表
 * 用于获取权限后，生成对应的路由，然后动态添加
 * 添加新页面后，到此处进行配置
 */
const routes = [
  {
    path: "/",
    redirect: "justlink/index",
    meta: {
      requiresAuth: true,
      noPermission: true,
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: (resolve) => require(["@/pages/layout/Layout"], resolve),
    meta: {
      requiresAuth: true,
      noPermission: true,
    },
    children: [
      {
        path: "/site/index",
        name: "site-index",
        component: (resolve) => require(["@/pages/site/Index"], resolve),
        meta: {
          requiresAuth: true,
          noPermission: true,
        },
      },
      {
        path: "/site/update-pwd",
        name: "site-update-pwd",
        component: (resolve) => require(["@/pages/site/UpdatePwd"], resolve),
        meta: {
          requiresAuth: true,
          noPermission: true,
        },
      },
      {
        path: "/administrators/index",
        name: "administrators-index",
        component: (resolve) =>
          require(["@/pages/permission/AdministratorsIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/administrators/edit",
        name: "administrators-edit",
        component: (resolve) =>
          require(["@/pages/permission/AdministratorsEdit"], resolve),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/administrators/pwd",
        name: "administrators-pwd",
        component: (resolve) =>
          require(["@/pages/permission/AdministratorsPwd"], resolve),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/roles/index",
        name: "roles-index",
        component: (resolve) =>
          require(["@/pages/permission/RolesIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/roles/edit",
        name: "roles-edit",
        component: (resolve) =>
          require(["@/pages/permission/RolesEdit"], resolve),
        meta: {
          requiresAuth: true,
        },
      },

      /**
       * 主页
       */
      //主页统计
      {
        path: "/justlink/index",
        name: "justlink-index",
        component: (resolve) => require(["@/pages/home/HomeIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      /**
       * 机器管理
       */
      //机器ip列表
      {
        path: "/machine_ipaddress/index",
        name: "machine_ipaddress-index",
        component: (resolve) =>
          require(["@/pages/machine/IpaddressIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //自定义mac套餐列表
      {
        path: "/machine_macsetmealopening/index",
        name: "machine_macsetmealopening-index",
        component: (resolve) =>
          require(["@/pages/machine/MacSetmealOpening"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //导入文件设置MAC套餐
      {
        path: "/machine_macsetmealopening/edit",
        name: "machine_macsetmealopening-edit",
        component: (resolve) =>
          require(["@/pages/machine/MacSetmealOpeningEdit"], resolve),
        meta: {
          requiresAuth: true,
        },
      },
      //导入文件设置MAC套餐
      {
        path: "/machine_macsetmealopening/edit_mac",
        name: "machine_macsetmealopening-edit_mac",
        component: (resolve) =>
          require(["@/pages/machine/MacSetmealOpeningEditMac"], resolve),
        meta: {
          requiresAuth: true,
        },
      },
      //机型列表
      {
        path: "/machine_modlename/index",
        name: "machine_modlename-index",
        component: (resolve) =>
          require(["@/pages/machine/ModleNameIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/modlename/index_son",
        name: "machine_modlename-index2",
        component: (resolve) =>
          require(["@/pages/machine/Modle2NameIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //点歌机系统升级
      {
        path: "/song-system-upgrade/packageManagementList",
        name: "PackageManagementList",
        component: () =>
          import("@/pages/song-system-upgrade/PackageManagementList"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/song-system-upgrade/upgradeStrategyManagement",
        name: "UpgradeStrategyManagement",
        component: () =>
          import("@/pages/song-system-upgrade/UpgradeStrategyManagement"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/song-system-upgrade/equipmentUpgradeRecordLog",
        name: "EquipmentUpgradeRecordLog",
        component: () =>
          import("@/pages/song-system-upgrade/EquipmentUpgradeRecordLog"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //区间版本管理列表
      {
        path: "/interval_version/index",
        name: "interval_version-index",
        component: (resolve) =>
          require(["@/pages/machine/IntervalVersionIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/interval_version/index_son",
        name: "interval_version-index2",
        component: (resolve) =>
          require(["@/pages/machine/IntervalVersionIndex2"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //可用升级机器管理
      {
        path: "/interval_version/index_mobile",
        name: "interval_version-index_mobile",
        component: (resolve) =>
          require(["@/pages/machine/IntervalVersionIndexMac"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //地区机型限制管理
      {
        path: "/device/blacklist/index",
        name: "RegionalDeviceRestrictions",
        component: () => import("@/pages/machine/RegionalDeviceRestrictions"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      /**
       * 数据管理
       */
      //系统升级
      {
        path: "/systemupgrade/add",
        name: "systemupgrade-add",
        component: (resolve) =>
          require(["@/pages/systemupgrade/SystemUpdateAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //系统升级信息列表
      {
        path: "/systemupgrade/index",
        name: "systemupgrade-index",
        component: (resolve) =>
          require(["@/pages/systemupgrade/SystemUploadIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/webpay/list",
        name: "webpay-list",
        component: (resolve) =>
          require(["@/pages/webpay/webpayIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/webpay/user",
        name: "webpay-user",
        component: (resolve) => require(["@/pages/webpay/webpayUser"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/webpay/add/user",
        name: "webpay-add-user",
        component: (resolve) =>
          require(["@/pages/webpay/webpayUserAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      {
        path: "/webpay/update",
        name: "webpay-update",
        component: (resolve) => require(["@/pages/webpay/webpaySave"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/cdkey/list",
        name: "cdkey-list",
        component: (resolve) => require(["@/pages/cdkey/list"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/cdkey/add",
        name: "cdkey-add",
        component: (resolve) => require(["@/pages/cdkey/add"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //编辑系统升级信息列表信息
      {
        path: "/systemupgrade/edit",
        name: "systemupgrade-edit",
        component: (resolve) =>
          require(["@/pages/systemupgrade/SystemUpdateIndexEdit"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 点歌机管理
       */
      //点歌机信息列表
      {
        path: "/membermanage/index",
        name: "membermanage-index",
        component: (resolve) =>
          require(["@/pages/membermanage/MemberManageIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //编辑点歌机信息列表
      {
        path: "/membermanage/edit",
        name: "membermanage-edit",
        component: (resolve) =>
          require(["@/pages/membermanage/MemberManageEdit"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //添加点歌机
      {
        path: "/membermanage/add",
        name: "membermanage-add",
        component: (resolve) =>
          require(["@/pages/membermanage/MemberManageAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //禁用点歌机信息列表
      {
        path: "/membermanage/index_disabled",
        name: "membermanage-index_disabled",
        component: (resolve) =>
          require(["@/pages/membermanage/MemberManageIndexDisabled"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //海外点歌机信息列表
      {
        path: "/membermanage/overseas_index",
        name: "membermanage-overseas_index",
        component: (resolve) =>
          require(["@/pages/membermanage/MemberManageOverseasIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //编辑海外点歌机信息列表
      {
        path: "/membermanage/overseas_edit",
        name: "membermanage-overseas_edit",
        component: (resolve) =>
          require(["@/pages/membermanage/MemberManageOverseasEdit"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //出厂机器激活列表
      {
        path: "/factoryactivation/index",
        name: "factoryactivation-index",
        component: (resolve) =>
          require(["@/pages/membermanage/FactoryActivationIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //出厂机器激活详细信息
      {
        path: "/factoryactivation/get",
        name: "factoryactivation-get",
        component: (resolve) =>
          require(["@/pages/membermanage/FactoryActivationGet"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //点歌机信息列表--售后使用
      {
        path: "/membermanage/service/index",
        name: "membermanage-service-index",
        component: (resolve) =>
          require(["@/pages/membermanage/MemberManageServiceIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      /**
       * 机型保修管理
       */

      /**
       * 日志管理
       */
      //日志记录列表
      {
        path: "/memberlogs/index",
        name: "memberlogs-index",
        component: (resolve) =>
          require(["@/pages/memberlogs/MemberLogsIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //VIP操作详细日志
      {
        path: "/memberlogs/mac/index",
        name: "memberlogs-/mac-index",
        component: (resolve) =>
          require(["@/pages/memberlogs/MemberLogsMacIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //机器日志记录列表
      {
        path: "/memberlogs/add/index",
        name: "memberlogs-add-index",
        component: (resolve) =>
          require(["@/pages/memberlogs/MemberLogsAddIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //后台接口操作全日志列表
      {
        path: "/memberlogs/api-operate/index",
        name: "memberlogs-api-operate-index",
        component: (resolve) =>
          require(["@/pages/memberlogs/ApiOperateLogIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      {
        path: "/menu/index",
        name: "menu-index",
        component: (resolve) => require(["@/pages/menu/MenuIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "/menu/children",
        name: "menu-children",
        component: (resolve) => require(["@/pages/menu/MenuChildren"], resolve),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/menu/rights",
        name: "menu-rights",
        component: (resolve) => require(["@/pages/menu/MenuRights"], resolve),
        meta: {
          requiresAuth: true,
        },
      },

      /**
       * 扫码付费管理
       */
      //列表
      {
        path: "/sweeppayment/index",
        name: "sweeppayment-index",
        component: (resolve) =>
          require(["@/pages/sweeppayment/ProhibitMacIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //添加页面
      {
        path: "/sweeppayment/edit",
        name: "sweeppayment-edit",
        component: (resolve) =>
          require(["@/pages/sweeppayment/ProhibitMacEdit"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //批量删除页面
      {
        path: "/sweeppayment/deletes",
        name: "sweeppayment-deletes",
        component: (resolve) =>
          require(["@/pages/sweeppayment/ProhibitMacDeletes"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: true,
        },
      },

      /**
       * 出厂套餐管理
       */
      {
        path: "/factorypackage/list",
        name: "FactorypackageList",
        component: () => import("@/pages/factorypackage/list"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //添加出厂套餐
      {
        path: "/factorypackage/add",
        name: "factorypackage-add",
        component: (resolve) =>
          require(["@/pages/factorypackage/FactorypackageAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/factorypackage/index-shelves",
        name: "factorypackage-index-shelves",
        component: (resolve) =>
          require([
            "@/pages/factorypackage/FactorypackageIndexShelves",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/factorypackage/index-offshelfs",
        name: "factorypackage-index-offshelfs",
        component: (resolve) =>
          require([
            "@/pages/factorypackage/FactorypackageIndexOffShelfs",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //编辑点歌机信息列表
      {
        path: "/factorypackage/edit",
        name: "factorypackage-edit",
        component: (resolve) =>
          require(["@/pages/factorypackage/FactorypackageIndexEdit"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 商品管理
       */
      //添加商品
      {
        path: "/goods/add",
        name: "goods-add",
        component: (resolve) => require(["@/pages/goods/GoodsAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //添加商品套餐品项
      {
        path: "/goods/addItems",
        name: "goods-addItems",
        component: (resolve) =>
          require(["@/pages/goods/GoodsAddItems"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //商品未上架列表
      {
        path: "/goods/list/off_shelf",
        name: "goods-list-off_shelf",
        component: (resolve) =>
          require(["@/pages/goods/GoodsListOffShelf"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //编辑商品
      {
        path: "/goods/stores/edit",
        name: "goods-stores-edit",
        component: (resolve) => require(["@/pages/goods/GoodsEdit"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //商品已上架列表
      {
        path: "/goods/list/on_shelf",
        name: "goods-list-on_shelf",
        component: (resolve) =>
          require(["@/pages/goods/GoodsListOnShelf"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //商品已下架列表
      {
        path: "/goods/list/revoked",
        name: "goods-list-revoked",
        component: (resolve) =>
          require(["@/pages/goods/GoodsListRevoked"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //查看商品
      {
        path: "/goods/sale",
        name: "goods-sale",
        component: (resolve) => require(["@/pages/goods/GoodsSale"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //编辑语音商品
      {
        path: "/goods/stores/voice/edit",
        name: "goods-stores-voice-edit",
        component: (resolve) =>
          require(["@/pages/goods/GoodsVoiceEdit"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //查看语音商品
      {
        path: "/goods/voice/sale",
        name: "goods-voice-sale",
        component: (resolve) =>
          require(["@/pages/goods/GoodsVoiceSale"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //编辑SVIP商品
      {
        path: "/goods/stores/svip/edit",
        name: "goods-stores-svip-edit",
        component: (resolve) =>
          require(["@/pages/goods/GoodsSvipEdit"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //查看SVIP商品
      {
        path: "/goods/svip/sale",
        name: "goods-svip-sale",
        component: (resolve) =>
          require(["@/pages/goods/GoodsSvipSale"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 数据管理
       */
      //添加歌单数据
      {
        path: "/music/song_list/add",
        name: "music-song_list-add",
        component: (resolve) =>
          require(["@/pages/songdatamanagement/SongListAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //歌单数据信息列表
      {
        path: "/music/song_list/list",
        name: "music-song_list-list",
        component: (resolve) =>
          require(["@/pages/songdatamanagement/SongListInformation"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //歌单组列表
      {
        path: "/music/song_group/list",
        name: "music-song_group-list",
        component: (resolve) =>
          require(["@/pages/songdatamanagement/SongListGroupIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //MAC歌单组指定列表
      {
        path: "/music/song_group_mac/list",
        name: "music-song_group_mac-list",
        component: (resolve) =>
          require([
            "@/pages/songdatamanagement/SongListGroupMacIndex",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //微信歌单组标识管理
      {
        path: "/music/wechat/song_list/id",
        name: "music-wechat-song_list-id",
        component: (resolve) =>
          require([
            "@/pages/songdatamanagement/WecharSongListIDindex",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //歌单类型管理
      {
        path: "/music/song_type/index",
        name: "music-song_type-index",
        component: (resolve) =>
          require(["@/pages/songdatamanagement/SonglistTypeIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 定制歌库管理
       */
      //获取定制歌库列表
      {
        path: "/member/geku/list",
        name: "member-geku-list",
        component: (resolve) =>
          require(["@/pages/geku/MemberGekuList"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //自定义机型歌库
      {
        path: "/member/geku/add",
        name: "MemberGekuAdd",
        component: (resolve) =>
          require(["@/pages/geku/MemberGekuadd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //编辑歌库
      {
        path: "/member/geku/edit",
        name: "member-geku-edit",
        component: (resolve) =>
          require(["@/pages/geku/MemberGekuEdit"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //获取歌库类型数据列表
      {
        path: "/member/geku/type/list",
        name: "member-geku-type-list",
        component: (resolve) =>
          require(["@/pages/geku/MemberGekuTypeList"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      {
        path: "/member/geku/macConfigureSongLibrary/list",
        name: "MacConfigureSongLibrary",
        component: (resolve) =>
          require(["@/pages/geku/MacConfigureSongLibrary"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/member/geku/libraryRegionSetup/list",
        name: "LibraryRegionSetup",
        component: () => import("@/pages/geku/libraryRegionSetup"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/member/geku/defaultRegionSongConfig",
        name: "DefaultRegionSongConfig",
        component: () => import("@/pages/geku/defaultRegionSongConfig"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      /**
       * 天音下载歌库管理
       */
      //根据机型设置天音下载接口指定歌库
      {
        path: "/tianyin/downloadn/geku_add",
        name: "tianyin-downloadn-geku_add",
        component: (resolve) =>
          require(["@/pages/tianyindownload/TianyinDownloadGekuAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //获取天音下载指定机型使用歌库列表
      {
        path: "/tianyin/downloadn/geku_list",
        name: "tianyin-downloadn-geku_list",
        component: (resolve) =>
          require(["@/pages/tianyindownload/TianyinDownloadGekuList"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 服务器管控
       */
      //服务器授权列表页面
      {
        path: "/server/authorize/index",
        name: "server-authorize-index",
        component: (resolve) =>
          require(["@/pages/server/ServerAuthorizeIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 商品订单流水
       */

      // 聚合订单管理（统一入口，可切换各业务线订单）
      {
        path: "/order/index",
        name: "OrderAggregateIndex",
        component: () => import("@/pages/order/OrderAggregateIndex"),
        meta: {
          requiresAuth: true,
          keepAlive: true,
        },
      },

      //商户收款切换管理
      {
        path: "/payment/change/index",
        name: "/payment/change/index",
        component: (resolve) =>
          require(["@/pages/order/PayMentChangeIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //CDN商品订单流水页面
      {
        path: "/webpay/order",
        name: "webpay-order",
        component: (resolve) => require(["@/pages/order/webpayOrder"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/order/cdn/orderindex",
        name: "order-cdn-orderindex",
        component: (resolve) =>
          require(["@/pages/order/CdnOrderFlowIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //语音商品订单流水页面
      {
        path: "/order/voice/orderindex",
        name: "order-voice-orderindex",
        component: (resolve) =>
          require(["@/pages/order/VoiceOrderFlowIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //SVIP商品订单流水页面
      {
        path: "/order/svip/orderindex",
        name: "order-svip-orderindex",
        component: (resolve) =>
          require(["@/pages/order/SvipOrderFlowIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //皮肤商品订单流水页面
      {
        path: "/order/skinmall/orderindex",
        name: "order-skinmall-orderindex",
        component: (resolve) =>
          require(["@/pages/order/SkinMallOrderFlowIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //退款订单管理
      {
        path: "/order/cdn/order/refundIndex",
        name: "order-cdn-order-refundIndex",
        component: (resolve) =>
          require(["@/pages/order/ReFundOrderFlowIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //酷狗订单流水页面
      {
        path: "/order/kugou/kugouIndex",
        name: "kugou-order",
        component: (resolve) =>
          require(["@/pages/order/KugouOrderFlowIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/order/appSongRequest/index",
        name: "AppSongRequestOrder",
        component: () => import("@/pages/order/AppSongRequestOrder"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //粤语点歌已付款订单流水
      {
        path: "/order/yueyu/song/index",
        name: "YueyuSongOrderFlowIndex",
        component: () => import("@/pages/order/YueyuSongOrderFlowIndex"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //点歌全民会员组合套餐已付款订单流水
      {
        path: "/order/combo/package/index",
        name: "ComboPackageOrderFlowIndex",
        component: () => import("@/pages/order/ComboPackageOrderFlowIndex"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //微信小程序会员订单页面
      {
        path: "/order/wx/WxMemberIndex",
        name: "WxMemberIndex",
        component: (resolve) =>
          require(["@/pages/order/WxGoodOrderIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 皮肤商城
       */
      //上传皮肤
      {
        path: "/skin/mall/upload",
        name: "skin-mall-upload",
        component: (resolve) =>
          require(["@/pages/skinmall/SkinMallPackageUpload"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //皮肤标签管理页面
      {
        path: "/skin/mall/tagtype/index",
        name: "skin-mall-tagtype/index",
        component: (resolve) =>
          require(["@/pages/skinmall/SongMallTagTypeIndex.vue"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //皮肤列表管理页面
      {
        path: "/skin/mall/index",
        name: "skin-mall/index",
        component: (resolve) =>
          require(["@/pages/skinmall/SkinMallIndex.vue"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //查看皮肤列表详情
      {
        path: "/skin/mall/sale",
        name: "skin-mall-sale",
        component: (resolve) =>
          require(["@/pages/skinmall/SkinMallSale"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //查看皮肤列表修改基本信息
      {
        path: "/skin/mall/UpdataSale",
        name: "skin-mall-UpdataSale",
        component: (resolve) =>
          require(["@/pages/skinmall/SkinMallUpdataSale"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //皮肤版本号页面
      {
        path: "/skin/mall/version/index",
        name: "skin-mall-version/index",
        component: (resolve) =>
          require(["@/pages/skinmall/SongMallVersionIndex.vue"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * CPUID绑定MAC管理
       */
      //上传皮肤

      //皮肤列表管理页面
      {
        path: "/cpuid/mac/index",
        name: "cpuid-mac/index",
        component: (resolve) =>
          require(["@/pages/cpuid/CpuIDMacIndex.vue"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      // 非法机器白名单列表
      {
        path: "/cpuid/unauthorized-device-registry",
        name: "UnauthorizedDeviceRegistry",
        component: (resolve) =>
          require(["@/pages/cpuid/UnauthorizedDeviceRegistry.vue"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/cpuid/MachineBindManagementList",
        name: "MachineBindManagementList",
        component: () => import("@/pages/cpuid/MachineBindManagementList.vue"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      /**
       * 机型限速功能管理
       */

      //获取机型云端歌曲数列表
      {
        path: "/song/total/list",
        name: "song-total-list",
        component: (resolve) =>
          require(["@/pages/songtotal/MemberSongTotalIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * YouTubeID管理
       */
      //YouTubeID管理
      {
        path: "/youtube/group/list",
        name: "youtube-group-list",
        component: (resolve) =>
          require(["@/pages/youtubeKey/YouTubeGroup"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //YouTubeKEY列表
      {
        path: "/youtube/list",
        name: "youtube-list",
        component: (resolve) =>
          require(["@/pages/youtubeKey/YouTubeIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //YouTubeKEY授权
      {
        path: "/youtube/authorize/list",
        name: "youtube-authorize-list",
        component: (resolve) =>
          require(["@/pages/youtubeKey/YouTubeAuthorizeIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/youtube/data/list",
        name: "YoutubeDataList",
        component: () => import("@/pages/YouTube/dataList"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      /**
       * 用户反馈
       */
      //用户反馈列表页
      {
        path: "/user/feed/backindex",
        name: "user-feed-backindex",
        component: (resolve) =>
          require(["@/pages/userfeedback/userFeedBack"], resolve),
        meta: {
          requiresAuth: false,
          keepAlive: false,
        },
      },

      //微信付款 投诉
      {
        path: "/user/feed/complaintIndex",
        name: "user-feed-complaintIndex",
        component: (resolve) =>
          require(["@/pages/userfeedback/complaintIndex"], resolve),
        meta: {
          requiresAuth: false,
          keepAlive: false,
        },
      },
      {
        path: "/user/feedbackCenter",
        name: "FeedbackCenter",
        component: () => import("@/pages/userfeedback/feedbackCenter"),
        meta: {
          requiresAuth: false,
          keepAlive: false,
        },
      },
      /**
       * 消息推送
       */
      {
        path: "/messagepush/list",
        name: "messagepush-list",
        component: (resolve) =>
          require(["@/pages/messagepush/MessagePushIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //编辑消息
      {
        path: "/messagepush/edit",
        name: "messagepush-edit",
        component: (resolve) =>
          require(["@/pages/messagepush/editMessage"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //添加消息
      {
        path: "/messagepush/add",
        name: "messagepush-add",
        component: (resolve) =>
          require(["@/pages/messagepush/addMessage"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      // settle user_amount
      {
        path: "/customized/settle/user_amount/index",
        name: "SettleUserAmountIndex",
        component: () => import("@/pages/custuser/settleUserAmountIndex"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      /**
       * 定制客户管理
       */
      {
        path: "/customized/user/list",
        name: "customized-user-list",
        component: (resolve) =>
          require(["@/pages/custuser/CustUserManageIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //添加账号
      {
        path: "/customized/user/add",
        name: "customized-user-add",
        component: (resolve) =>
          require(["@/pages/custuser/CustUserAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 统计管理
       */
      //MAC激活数统计
      {
        path: "/statisticsmanage/macRegister/list",
        name: "customized-macRegister-list",
        component: (resolve) =>
          require(["@/pages/statisticsmanage/StatisticsMacRegister"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //开机数统计
      {
        path: "/statisticsmanage/macAction/list",
        name: "customized-macAction-list",
        component: (resolve) =>
          require(["@/pages/statisticsmanage/StatisticsMacAcion"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //城市机器分布统计
      {
        path: "/ipaddress/city/index",
        name: "statisticsmanage-paddress-cityindex",
        component: (resolve) =>
          require([
            "@/pages/statisticsmanage/IpaddressCityStatistics",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //开机数统计
      {
        path: "/statisticsMacSong/MacDownload/list",
        name: "song-list",
        component: (resolve) =>
          require(["@/pages/statisticsmanage/StatisticsSongDownload"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //VIP账单统计
      {
        path: "/statisticsVipBill/total/index",
        name: "vip-bill-list",
        component: (resolve) =>
          require(["@/pages/statisticsmanage/BillVipStatistics"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //歌曲点播率查看
      {
        path: "/songClickIndex/click/index",
        name: "song-click-list",
        component: (resolve) =>
          require(["@/pages/statisticsmanage/SongClickIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //歌曲下载榜单
      {
        path: "/songDownloadIndex/download/index",
        name: "song-download-list",
        component: (resolve) =>
          require(["@/pages/statisticsmanage/SongDownloadIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 3128在线升级管理
       */
      //获取3128在线升级列表
      {
        path: "/3128/versionUpgrade/list",
        name: "versionUpgrade-list",
        component: (resolve) =>
          require(["@/pages/3128/VersionUpgrade3128Index"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //添加3128在线升级列表
      {
        path: "/3128/versionUpgrade/Add",
        name: "versionUpgrade-add",
        component: (resolve) =>
          require(["@/pages/3128/VersionUpgrade3128Add"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 腾讯会员商品管理
       */
      //添加会员CODE
      {
        path: "/tencent/video/code/add",
        name: "tencent-video-code-add",
        component: (resolve) =>
          require(["@/pages/tencent/TentCentVideoCodeAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //会员码列表
      {
        path: "/tencent/video/code/index",
        name: "tencent-video-code-index",
        component: (resolve) =>
          require(["@/pages/tencent/TentCentVideoCodeIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //会员购买列表
      {
        path: "/tencent/video/code/order",
        name: "tencent-video-code-order",
        component: (resolve) =>
          require(["@/pages/tencent/TenCentVideoCodeOrder"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 机器下载白名单管理
       */
      //机器授权白名单管理
      {
        path: "/white/mac/index",
        name: "white-mac-index",
        component: (resolve) =>
          require(["@/pages/whitedownload/DownloadWhiteIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //机器每日下载数
      {
        path: "/download/number/index",
        name: "download-number-index",
        component: (resolve) =>
          require(["@/pages/whitedownload/DownloadIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //24年春节下载限制管理
      {
        path: "/down/24/limitation/index",
        name: "download-LimitAtion-24-index",
        component: (resolve) =>
          require(["@/pages/whitedownload/24DownLimitAtionIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //报警监控：异常注册、异常下载
      {
        path: "/alarm/monitor/index",
        name: "alarm-monitor-index",
        component: (resolve) =>
          require(["@/pages/alarm/AlarmMonitorIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
          noPermission: true,
        },
      },
      // 测试管理：客户自测地址
      {
        path: "/test/manage/index",
        name: "test-manage-index",
        component: (resolve) =>
          require(["@/pages/testmanage/TestManageIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
          noPermission: true,
        },
      },
      //24年春节下载限制管理白名单
      {
        path: "/down/limitation/24/white/index",
        name: "download-LimitAtion-24-white-index",
        component: (resolve) =>
          require([
            "@/pages/whitedownload/24DownLimitAtionWhiteIndex",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 播放下载配置
       */
      //播放下载配置管理
      {
        path: "/nodevip/mode/index",
        name: "nodevip-mode-index",
        component: (resolve) =>
          require(["@/pages/novipmode/NovipModeIndexl"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * H5网页支付
       */
      {
        path: "/payh5/uesr/index",
        name: "payh5-uesr-index",
        component: (resolve) =>
          require(["@/pages/payh5/PayH5UserIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/payh5/uesr/add",
        name: "payh5-uesr-add",
        component: (resolve) =>
          require(["@/pages/payh5/PayH5UserAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 机器服务器配置
       */
      {
        path: "/server/configuration/dispose",
        name: "server-configuration-dispose",
        component: (resolve) =>
          require(["@/pages/serverconfig/MacServerConfig"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/server/configuration/dispose/index",
        name: "server-configuration-dispose/index",
        component: (resolve) =>
          require(["@/pages/serverconfig/MacServerConfigIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 酷狗机器管理
       */

      {
        path: "/kugou/activation/index",
        name: "kugou-activation-index",
        component: (resolve) =>
          require(["@/pages/kugoumanage/KugouIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      {
        path: "/kugou/authorize/index",
        name: "kugou-activation-index",
        component: (resolve) =>
          require(["@/pages/kugoumanage/KugouAuthorizeIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/kugou/authorize/batch/add",
        name: "kugou-activation-batch-add",
        component: (resolve) =>
          require(["@/pages/kugoumanage/KugouBatchAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      {
        path: "/kugou/mac/vip/to/index",
        name: "kugou-mac-vip-to-index",
        component: (resolve) =>
          require(["@/pages/kugoumanage/KugouVipToMacIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      {
        path: "/kugou/sn/reset/index",
        name: "kugou-sn-reset-index",
        component: (resolve) =>
          require(["@/pages/kugoumanage/KugouSNResetIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      {
        path: "/kugou/vip/log/index",
        name: "kugou-log-index",
        component: (resolve) =>
          require(["@/pages/kugoumanage/KugouLogIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      {
        path: "/kugou/recycle/index",
        name: "kugou-recycle-index",
        component: (resolve) =>
          require(["@/pages/kugoumanage/KugouRecycleIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 全民K歌管理
       */

      //授权列表
      {
        path: "/tencetn/qmkg/authorize/index",
        name: "tencetn-qmkg-authorize-index",
        component: (resolve) =>
          require([
            "@/pages/quanminKgeManage/QuanMingKgeAuthorizeIndex",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //激活列表
      {
        path: "/tencetn/qmkg/activation/index",
        name: "tencetn-qmkg-activation-index",
        component: (resolve) =>
          require(["@/pages/quanminKgeManage/QuanMingKgeUserIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //订单列表列表
      {
        path: "/tencetn/qmkg/order/index",
        name: "tencetn-qmkg-order-index",
        component: (resolve) =>
          require([
            "@/pages/quanminKgeManage/QuanMingKgeOrderFlowIndex",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //用户级Token列表
      {
        path: "/tencetn/qmkg/getToken/index",
        name: "tencetn-qmkg-getToken-index",
        component: (resolve) =>
          require([
            "@/pages/quanminKgeManage/QuanMingKgeGetTokenIndex",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //上线列表
      {
        path: "/tencetn/qmkg/online/index",
        name: "tencetn-qmkg-online-index",
        component: (resolve) =>
          require(["@/pages/quanminKgeManage/QuanMingKgeOnlineIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //退货审核列表
      {
        path: "/tencetn/qmkg/return/examine/index",
        name: "tencetn-qmkg-return-examine-index",
        component: (resolve) =>
          require([
            "@/pages/quanminKgeManage/QuanMingKgeReturnExamineIndex",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //设备使用CDK列表
      {
        path: "/tencetn/qmkg/cdk/apply/index",
        name: "tencetn-qmkg-cdk/apply-index",
        component: (resolve) =>
          require([
            "@/pages/quanminKgeManage/QuanMingKgeCdkApplyIndex",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //设备转移列表
      {
        path: "/tencetn/qmkg/cdk/transfer/index",
        name: "tencetn-qmkg-cdk/transfer-index",
        component: (resolve) =>
          require([
            "@/pages/quanminKgeManage/QuanMingKgeTransferIndex",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 主页定制模块
       */

      //主题列表
      {
        path: "/homecust/home/cust/theme/list",
        name: "homecust-home-cust-theme-list",
        component: (resolve) =>
          require(["@/pages/homecust/HomeCustThemeIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //上传主页定制包
      {
        path: "/homecust/home/cust/version/add",
        name: "homecust-home-cust-version-add",
        component: (resolve) =>
          require(["@/pages/homecust/HomeCustVersionAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //主页定制列表
      {
        path: "/homecust/home/cust/version/list",
        name: "homecust-home-cust-version-list",
        component: (resolve) =>
          require(["@/pages/homecust/HomeCustVersionIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //主页定制列表
      {
        path: "/homecust/home/cust/specify/list",
        name: "homecust-home-cust-specify-list",
        component: (resolve) =>
          require(["@/pages/homecust/HomeCustSpecifyIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      //Launcher预安装包列表
      {
        path: "/homecust/home/cust/launcher/list",
        name: "homecust-home-cust-launcher-list",
        component: (resolve) =>
          require(["@/pages/homecust/HomeCustLauncherIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * APP类型管理
       */
      //类型列表
      {
        path: "/app/types/list",
        name: "app-types-list",
        component: (resolve) =>
          require(["@/pages/apptypes/AppTypesIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //上传APP包
      {
        path: "/app/types/appid/version/add",
        name: "app-types-appid-version-add",
        component: (resolve) =>
          require(["@/pages/apptypes/AppTypesVersionAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //Apk包列表
      {
        path: "/app/types/appid/version/index",
        name: "app-types-appid-version-index",
        component: (resolve) =>
          require(["@/pages/apptypes/AppApkVersionIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //Apk包列表
      {
        path: "/app/types/appid/specify/index",
        name: "app-types-appid-specify-index",
        component: (resolve) =>
          require(["@/pages/apptypes/AppTypesSpecifyIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },

      /**
       * 音集协白名单配置
       */
      {
        path: "/yjx/white/configuration/dispose",
        name: "yjx-white-configuration-dispose",
        component: (resolve) =>
          require(["@/pages/yjxWhiteConfig/ModelYjxWhiteConfig"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/yjx/white/configuration/dispose/index",
        name: "yjx-white-configuration-dispose/index",
        component: (resolve) =>
          require(["@/pages/yjxWhiteConfig/YjxWhiteConfigIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/yjx/white/configuration/record/index",
        name: "yjx-white-configuration-record/index",
        component: (resolve) =>
          require(["@/pages/yjxWhiteConfig/YjxWhiteRecordIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/yjx/white/configuration/dispose/brief/index",
        name: "yjx-white-configuration-brief-dispose/index",
        component: (resolve) =>
          require(["@/pages/yjxWhiteConfig/YjxWhiteBriefConfigIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/yjx/prepaid/index",
        name: "yjx-prepaid-/index",
        component: (resolve) =>
          require(["@/pages/yjxWhiteConfig/YjxPrepaidMacIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/yjx/black/disable/index",
        name: "yjx-black-disable-index",
        component: (resolve) =>
          require(["@/pages/yjxWhiteConfig/YjxBlackDisableIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
          noPermission: true,
        },
      },
      {
        path: "/machine/wechat/ws/index",
        name: "machine-wechat-ws-index",
        component: (resolve) =>
          require(["@/pages/yjxWhiteConfig/YjxBlackDisableIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
          noPermission: true,
        },
      },
      {
        path: "/yjx/sdk/charging/index",
        name: "SDKFeeList",
        component: (resolve) =>
          require(["@/pages/yjxWhiteConfig/SDKFeeList"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/yjx/sdk/cavca-pop-up/index",
        name: "CavcaPopUp",
        component: (resolve) =>
          require(["@/pages/yjxWhiteConfig/CavcaPopUp"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/yjx/sdk/cavca-sdk-member/index",
        name: "CavcaSDKMemberList",
        component: (resolve) =>
          require(["@/pages/yjxWhiteConfig/CavcaSDKMemberList"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      /**
       * APK点歌版本管理
       */
      //上传APK版本Launcher应用组更新
      {
        path: "/apk/device/launcher/add/index",
        name: "apk-device-launcher-add",
        component: (resolve) =>
          require(["@/pages/apkdevice/ApkDeviceLauncherAdd"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //Apk列表
      {
        path: "/apk/device/launcher/list/index",
        name: "apk-device-launcher-list",
        component: (resolve) =>
          require(["@/pages/apkdevice/ApkDeviceLauncherList"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      // MAC版-APK上传
      {
        path: "/apk/collection/index",
        name: "apk-collection-index",
        component: (resolve) =>
          require(["@/pages/apkdevice/ApkCollectionIndex"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "/apk/device/model_management",
        name: "ModelManagement",
        component: () => import("@/pages/apkdevice/model-management/index"),
        meta: {
          requiresAuth: true,
          noPermission: true,
        },
      },
      {
        path: "/apk/device/cdk/generate_management",
        name: "CDKGenerateManagement",
        component: () =>
          import("@/pages/apkdevice/CDK-generate-management/index"),
        meta: {
          requiresAuth: true,
          noPermission: true,
        },
      },
      //Apk列表
      {
        path: "/apk/active/list",
        name: "ApkActiveList",
        component: () => import("@/pages/apkdevice/ApkActiveList"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      // 体验套餐配置
      {
        path: "/apk/experience-package-configuration",
        name: "ExperiencePackageConfiguration",
        component: () =>
          import("@/pages/apkdevice/experience-package-configuration"),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      // 机型渠道组管理
      {
        path: "/apk/device/model_channel_group_management",
        name: "ModelChannelGroupManagement",
        component: () =>
          import("@/pages/apkdevice/modelChannelGroupManagement/index"),
        meta: {
          requiresAuth: true,
          noPermission: true,
        },
        // model_channel_group_management
      },
      // 经销商管理
      {
        path: "/dealer_management",
        name: "DealerManagement",
        component: () => import("@/pages/dealerManagement/index"),
        meta: {
          requiresAuth: true,
          noPermission: true,
        },
      },
      /**
       * 新云猫歌单管理
       */
      /**
       * 数据管理
       */
      //添加歌单数据
      {
        path: "/music/new/song_list/add",
        name: "music-new/song_list-add",
        component: (resolve) =>
          require(["@/pages/newsongdatamanagement/SongListAddNew"], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //歌单数据信息列表
      {
        path: "/music/new/song_list/list",
        name: "music-new-song_list-list",
        component: (resolve) =>
          require([
            "@/pages/newsongdatamanagement/SongListInformationNew",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      //歌单类型管理
      {
        path: "/music/new/song_type/index",
        name: "music-new/song_type-index",
        component: (resolve) =>
          require([
            "@/pages/newsongdatamanagement/SonglistTypeIndexNew",
          ], resolve),
        meta: {
          requiresAuth: true,
          keepAlive: false,
        },
      },
      // 粤语点歌管理
      {
        path: "/cantonese-song-manage/auth-list",
        name: "CantoneseSongManageAuthList",
        component: () => import("@/pages/cantonese-song-manage/AuthList"),
        meta: {
          requiresAuth: true,
          noPermission: true,
        },
      },
      {
        path: "/cantonese-song-manage/member-list",
        name: "CantoneseSongManageMemberList",
        component: () => import("@/pages/cantonese-song-manage/MemberList"),
        meta: {
          requiresAuth: true,
          noPermission: true,
        },
      },
    ],
  },
  {
    path: "*",
    redirect: "/404",
    meta: {
      requiresAuth: false,
      noPermission: true,
    },
  },
];

function generateRouteByPermision(routes, permission) {
  let filter_result = [];
  for (let i = 0; i < routes.length; i++) {
    if (routes[i].children && routes[i].children.length > 0) {
      let children_result = generateRouteByPermision(
        routes[i].children,
        permission
      );
      if (children_result.length > 0) {
        routes[i].children = children_result;
        filter_result.push(routes[i]);
      } else {
        routes[i].children = [];
        if (
          routes[i].meta.noPermission ||
          permission.indexOf(routes[i].path) > -1
        ) {
          filter_result.push(routes[i]);
        }
      }
    } else {
      if (
        routes[i].meta.noPermission ||
        permission.indexOf(routes[i].path) > -1
      ) {
        filter_result.push(routes[i]);
      }
    }
  }

  if (permission[0] !== routes[0].redirect) {
    // console.log(permission[0],routes[0].redirect)
    routes[0].redirect = permission[0];
    //   console.log( routes[0].redirect)
  }

  return filter_result;
}

export default {
  routes: routes,
  generateRouteByPermision: generateRouteByPermision,
};



// WEBPACK FOOTER //
// ./src/router/dynamic-router.js